// Simplifies the low-stock message on this PDP template from "Only N units left" to "Only N left" —
// scoped to the inventory_pdp0408 block and the sticky add-to-cart bar specifically (the theme's shared
// locale string is left untouched, so cart/collection/other templates keep the standard wording).
// Observes document.body broadly rather than a single container reference, since the sticky bar's
// <product-rerender> wrapper can replace its own children (and the container itself) on variant
// switches, which would silently break a MutationObserver bound to a single stale container.
(function () {
  var UNITS_PATTERN = /\b(\d+)\s+units?\s+left\b/i;
  var CONTAINER_SELECTORS = '[data-block-id="inventory_pdp0408"], .product-sticky-bar';

  function simplify(container) {
    var walker = document.createTreeWalker(container, NodeFilter.SHOW_TEXT);
    var node;

    while ((node = walker.nextNode())) {
      if (UNITS_PATTERN.test(node.nodeValue)) {
        node.nodeValue = node.nodeValue.replace(UNITS_PATTERN, '$1 left');
      }
    }
  }

  function scan() {
    document.querySelectorAll(CONTAINER_SELECTORS).forEach(simplify);
  }

  function init() {
    scan();

    new MutationObserver(scan).observe(document.body, { childList: true, subtree: true, characterData: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
